<script lang="ts">let { size = "20" } = $props();
</script>

<svg
	height={size}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 28.35 28.35"
	><g
		><path d="m25.31 15.16-1.97 5.41 1.86 2.53c1.92-2.38 3.1-5.39 3.15-8.68z" /><path
			d="m24.05 13.76 4.23-1.03c-.16-1.54-.56-3-1.16-4.36l-4.18 1.22-5.77-4.84.47-4.33c-1.11-.28-2.27-.43-3.47-.43s-2.36.15-3.47.43l.48 4.33-5.77 4.84-4.18-1.22c-.6 1.35-1 2.82-1.16 4.36l4.23 1.03 2.58 7.08-2.58 3.51A13.9 13.9 0 0 0 8 26.93l2.41-3.62h7.54l2.42 3.62c1.37-.66 2.61-1.54 3.7-2.58l-2.58-3.51zm-6.78 4.56h-6.18l-2.04-6.1 5.13-4.1 5.13 4.1z"
		/><path
			d="m10.99 12.8 1.29 3.87h3.78l1.29-3.87-3.18-2.55zm-7.95 2.36L0 14.42c.06 3.29 1.22 6.3 3.15 8.68l1.86-2.53zm8.25 9.81-1.74 2.61c1.45.5 3 .77 4.62.77s3.17-.27 4.62-.77l-1.74-2.61h-5.77Zm15.04-18.1c-1.62-2.69-4.11-4.8-7.08-5.94l-.34 3.12 4.41 3.7zM9.43 4.05 9.09.93a14.24 14.24 0 0 0-7.08 5.94l3.01.88z"
		/></g
	></svg
>
